import { CelebrationsBirthdayPageTemplate } from "./template";
import { useCelebrationsBirthdayPage } from "./logic";

export const CelebrationsBirthdayPage = () : JSX.Element => {
    const props = useCelebrationsBirthdayPage();

    return (
        <CelebrationsBirthdayPageTemplate {...props}/>
    )
}